import React from "react"
import Publication from "~/components/twilio/Publication"

export default function ParticipantTracks({ userInfo, quality, isMain = false }) {
  return <Publication userInfo={userInfo} quality={quality} isMain={isMain} />
}
